import { chain, omit, flatMap } from 'lodash';
import { rangesForDate, isInTimeRange } from '../../helpers/time-ranges';
import doesMatchMultiFilter from '../../helpers/does-match-multi-filter';
import { cfEventToEventOccurrences, cfOfferToOfferOccurrences } from './contentful-to-whats-on';
function doesMatchWhatsOnMultiFilters(selectedFilters) {
  const get = (occurrence, key) => occurrence.item[key];
  return doesMatchMultiFilter(omit(selectedFilters, 'dateRange'), get);
}
function cfEntriesToOccurrences(baseDate, centre, entries, toOccurrences) {
  return flatMap(entries, entry => toOccurrences(baseDate, centre, entry));
}
function applyFiltersToCfOccurrences(selectedFilters, occurrences) {
  return occurrences.filter(doesMatchWhatsOnMultiFilters(selectedFilters));
}
function getOccurrencesByTimeRange(timeRange, filteredOccurrences, orderArgs) {
  return chain(filteredOccurrences).filter(isInTimeRange(timeRange)).uniqBy('item.slug').orderBy(...orderArgs).map('item').value();
}
export const getOcccurrencesLists = (baseDate, events, offers, centre) => {
  const eventsOccurrences = cfEntriesToOccurrences(baseDate, centre, events, cfEventToEventOccurrences);
  const offersOccurrences = cfEntriesToOccurrences(baseDate, centre, offers, cfOfferToOfferOccurrences);
  return {
    eventsOccurrences,
    offersOccurrences
  };
};
export const rangesFromOccurrencesListsAndFilters = (baseDate, occurrencesLists, selectedFilters) => {
  const {
    eventsOccurrences,
    offersOccurrences
  } = occurrencesLists;
  const filteredEvents = applyFiltersToCfOccurrences(selectedFilters, eventsOccurrences);
  const filteredOffers = applyFiltersToCfOccurrences(selectedFilters, offersOccurrences);
  return rangesForDate(baseDate, selectedFilters.dateRange).map(timeRange => {
    const whatsOnEvents = getOccurrencesByTimeRange(timeRange, filteredEvents, [['startAt', 'item.name'], ['asc', 'asc']]);
    const whatsOnOffers = getOccurrencesByTimeRange(timeRange, filteredOffers, [['item.timezonelessShowAtTimestamp', 'item.name'], ['desc', 'asc']]);
    return {
      name: timeRange.name,
      slug: timeRange.slug(),
      items: [...whatsOnEvents, ...whatsOnOffers]
    };
  });
};